export const translateNativeBase = (nativeBaseProps) => {
    let res = {}

    Object.entries(nativeBaseProps).forEach(([prop, value]) => {
        const cssKey = nativeBaseToReactStyle[prop]
        if(cssKey) {
            const val = valueTransformers(prop, value)
            if(val !== null && val !== undefined) {
                if (Array.isArray(cssKey)) {
                    cssKey.forEach(key => {
                        res[key] = val
                    })
                } else {
                    res[cssKey] = val
                }
            }
        }
    })

    return res;
}

const valueTransformers = (key, value) => {

    if (spacingProps.includes(key) && typeof value === 'number') {
        return `${value * 4}px`;
    }
    if (typeof value === 'string') {
        switch (value) {
            case 'xs': return '4px';
            case 'sm': return '8px';
            case 'md': return '12px';
            case 'lg': return '16px';
            case 'xl': return '24px';
            case '2xl': return '32px';
            case '3xl': return '48px';
            case '4xl': return '64px';
            default: return value; // If it's not a theme token, return as is
        }
    }
    return value;
};

const nativeBaseToReactStyle = {
    // Layout & Flex
    flex: 'flex',
    flexGrow: 'flexGrow',
    flexShrink: 'flexShrink',
    flexBasis: 'flexBasis',
    flexDirection: 'flexDirection',
    flexDir: 'flexDirection',
    flexWrap: 'flexWrap',
    alignItems: 'alignItems',
    justifyContent: 'justifyContent',
    alignSelf: 'alignSelf',
    alignContent: 'alignContent',
    order: 'order',
    gap: 'gap',
    rowGap: 'rowGap',
    columnGap: 'columnGap',
    textAlign: 'textAlign',
    direction: 'direction',
    dir: 'direction',
    writingDirection: 'writingDirection',

    // Spacing
    padding: 'padding',
    paddingTop: 'paddingTop',
    paddingBottom: 'paddingBottom',
    paddingLeft: 'paddingLeft',
    paddingRight: 'paddingRight',
    paddingX: ['paddingLeft', 'paddingRight'],
    paddingY: ['paddingTop', 'paddingBottom'],
    margin: 'margin',
    marginTop: 'marginTop',
    marginBottom: 'marginBottom',
    marginLeft: 'marginLeft',
    marginRight: 'marginRight',
    marginX: ['marginLeft', 'marginRight'],
    marginY: ['marginTop', 'marginBottom'],
    space: 'gap', // NativeBase's space prop maps to gap

    // Sizing
    width: 'width',
    height: 'height',
    minWidth: 'minWidth',
    minHeight: 'minHeight',
    maxWidth: 'maxWidth',
    maxHeight: 'maxHeight',

    // Position
    position: 'position',
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left',
    zIndex: 'zIndex',

    // Overflow
    overflow: 'overflow',
    overflowX: 'overflowX',
    overflowY: 'overflowY',

    // Display & Visibility
    display: 'display',
    visibility: 'visibility',
    opacity: 'opacity',
    cursor: 'cursor',
    fontSize: 'fontSize',
    color: 'color',

    // Background
    backgroundColor: 'backgroundColor',
    bgColor: 'backgroundColor',
    backgroundImage: 'backgroundImage',
    backgroundSize: 'backgroundSize',
    backgroundPosition: 'backgroundPosition',
    backgroundRepeat: 'backgroundRepeat',

    // Shorthand props
    bg: 'backgroundColor',
    p: 'padding',
    px: ['paddingLeft', 'paddingRight'],
    py: ['paddingTop', 'paddingBottom'],
    pt: 'paddingTop',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    pr: 'paddingRight',

    m: 'margin',
    mx: ['marginLeft', 'marginRight'],
    my: ['marginTop', 'marginBottom'],
    mt: 'marginTop',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mr: 'marginRight',

    w: 'width',
    h: 'height',
    minW: 'minWidth',
    maxW: 'maxWidth',
    minH: 'minHeight',
    maxH: 'maxHeight',

    // Border Style
    borderStyle: 'borderStyle',
    borderTopStyle: 'borderTopStyle',
    borderBottomStyle: 'borderBottomStyle',
    borderLeftStyle: 'borderLeftStyle',
    borderRightStyle: 'borderRightStyle',

    // Border Width
    borderWidth: 'borderWidth',
    borderTopWidth: 'borderTopWidth',
    borderBottomWidth: 'borderBottomWidth',
    borderLeftWidth: 'borderLeftWidth',
    borderRightWidth: 'borderRightWidth',

    // Border Color
    borderColor: 'borderColor',
    borderTopColor: 'borderTopColor',
    borderBottomColor: 'borderBottomColor',
    borderLeftColor: 'borderLeftColor',
    borderRightColor: 'borderRightColor',

    // Border Radius
    borderRadius: 'borderRadius',
    borderTopLeftRadius: 'borderTopLeftRadius',
    borderTopRightRadius: 'borderTopRightRadius',
    borderBottomLeftRadius: 'borderBottomLeftRadius',
    borderBottomRightRadius: 'borderBottomRightRadius',

    // Shorthand props
    border: 'border',
    borderTop: 'borderTop',
    borderBottom: 'borderBottom',
    borderLeft: 'borderLeft',
    borderRight: 'borderRight',

    // NativeBase specific shorthands
    borderW: 'borderWidth',
    borderX: ['borderLeftWidth', 'borderRightWidth'],
    borderY: ['borderTopWidth', 'borderBottomWidth'],
    borderT: 'borderTopWidth',
    borderB: 'borderBottomWidth',
    borderL: 'borderLeftWidth',
    borderR: 'borderRightWidth',

    // Transform
    transform: 'transform',
    translateX: 'translateX',
    translateY: 'translateY',
    scale: 'scale',
    scaleX: 'scaleX',
    scaleY: 'scaleY',
    rotate: 'rotate',
    rotateX: 'rotateX',
    rotateY: 'rotateY',
    skewX: 'skewX',
    skewY: 'skewY',
};

const spacingProps = [
    'space',
    'p',
    'px',
    'py',
    'pt',
    'pb',
    'pl',
    'pr',
    'm',
    'mx',
    'my',
    'mt',
    'mb',
    'ml',
    'mr',
    'padding',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'margin',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom',
];